<template>
  <main class="container solution-viruscare">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">Viruscare Solution</button>
      <h1>
        Scientific Management by
        <br />
        Antimicrobial Safety Experts
      </h1>
      <p>
        Access solutions for managing infectious agents, including viruses, bacteria,
        <br class="pc_show" />
        and harmful germs.
      </p>

      <router-link to="/contact/mail/send?local=eng">
        <p ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]">Send Email</p>
      </router-link>
    </section>

    <img
      :src="require(`@/assets/images/solution/viruscare/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [Solution] Viruscare Solution"
    />

    <section class="section solution-viruscare-1">
      <div class="contents-center">
        <h3 class="title-section">Humans are the hosts for viruses, transmitting them through droplets such as saliva and nasal fluid.</h3>
        <p class="description-section">
          A single cough releases 3,000 droplets, while a sneeze can propel 100,000 droplets at speeds up to 140 km/h, rapidly spreading like fog
          throughout an area.
        </p>
        <img class="section-img" src="@/assets/images/solution/viruscare/section_img.png" alt="CESCO [Solution] Viruscare Solution" />
        <div class="card-list">
          <div class="card">
            <h4 class="title">Direct <br class="mo_show" />Transmission</h4>
            <p class="number">01</p>
            <p class="tag">
              #Maintain a distance of
              <br />
              more than 2 meters
            </p>
            <p class="description">
              Droplets larger than 5 _m can travel up to 2 meters, directly contacting the mucous membranes of the eyes, nose, and mouth, causing
              infection.
            </p>
          </div>
          <div class="card">
            <h4 class="title">Indirect <br class="mo_show" />Transmission</h4>
            <p class="number">02</p>
            <p class="tag">#Virus survival up to 9 days</p>
            <p class="description">
              Depending on their size, droplets can travel over 4 meters in the air and land on surfaces such as handles, becoming a source of
              infection.
            </p>
          </div>
          <div class="card">
            <h4 class="title">Airborne <br class="mo_show" />Transmission</h4>
            <p class="number">03</p>
            <p class="tag">#Air Disinfection</p>
            <p class="description">
              Droplets smaller than 3 _m form a fine particle mixture (aerosols) that floats in the air, facilitating wide transmission.
            </p>
          </div>
          <div class="card">
            <h4 class="title">Fecal/Oral <br class="mo_show" />Transmission</h4>
            <p class="number">04</p>
            <p class="tag">#Virus survival up to 9 days</p>
            <p class="description">
              Flushing a toilet can aerosolize the virus with water droplets up to 6 meters, leading to potential inhalation or surface transmission.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section solution-viruscare-2">
      <div class="contents-center">
        <div class="card-list">
          <div class="card">
            <div>
              <h4>Global infectious diseases tend to peak every 6 years.</h4>
              <p>Five years have passed since the last major outbreak. What’s next?</p>
            </div>
            <img src="@/assets/images/solution/viruscare/card_list_01.svg" alt="CESCO [Solution] Viruscare Solution" />
          </div>
          <div class="card">
            <div>
              <h4>Annual outbreaks of acute respiratory infection 'Influenza'</h4>
              <p>
                'Influenza,' an acute respiratory infection caused by the influenza virus, occurs annually, while pneumonia, particularly risky for
                infants, recurs every 3-5 years during seasonal changes, posing a threat to daily life.
              </p>
            </div>
            <img src="@/assets/images/solution/viruscare/card_list_02.png" alt="CESCO [Solution] Viruscare Solution" />
          </div>
        </div>
      </div>
    </section>

    <section class="section solution-viruscare-3">
      <div class="contents-center">
        <h3 class="title-section">What is the Viruscare Solution?</h3>
        <p class="description-section">
          This solution leverages expertise from managing virus pandemics such as MERS, swine flu, SARS, and COVID-19 to systematically diagnose and
          block routes of infection from viruses, bacteria, and other germs, effectively preventing them.
        </p>
        <div class="card-grid">
          <div class="card-type-a bg-img-card-f-1" @click="handleVirusCareClick(0)">
            <div class="font-card">
              <h4>Sterilization management is conducted by our CESCO experts.</h4>
              <img src="@/assets/images/icons/add-icon.svg" class="add-icon" alt="CESCO [Solution] Viruscare Solution" />
            </div>
            <div class="back-card background-wrapper">
              <img src="@/assets/images/solution/viruscare/back_card_01.png" alt="CESCO [Solution] Viruscare Solution" />
              <div class="content">
                <h4>Sterilization management is conducted by our CESCO experts</h4>
                <p>The process involves preemptively diagnosing virus transmission routes and managing sterilization.</p>
              </div>
            </div>
          </div>
          <div class="card-type-a bg-img-card-f-2" @click="handleVirusCareClick(1)">
            <div class="font-card">
              <h4>Activating a preemptive attack system against airborne influenza viruses and pneumonia</h4>
              <img src="@/assets/images/icons/add-icon.svg" class="add-icon" alt="CESCO [Solution] Viruscare Solution" />
            </div>
            <div class="back-card background-wrapper">
              <img src="@/assets/images/solution/viruscare/back_card_02.png" alt="CESCO [Solution] Viruscare Solution" />
              <div class="content">
                <h4>Activating a preemptive attack system against airborne influenza viruses and pneumonia</h4>
                <p>
                  CESCO air sterilizers forcibly inhale contaminated air before bacteria and viruses can attack people, performing preemptive
                  sterilization.
                </p>
              </div>
            </div>
          </div>
          <div class="card-type-a bg-img-card-f-3" @click="handleVirusCareClick(2)">
            <div class="font-card">
              <h4>Providing touchless automatic dispensers to prevent cross-contamination</h4>
              <img src="@/assets/images/icons/add-icon.svg" class="add-icon" alt="CESCO [Solution] Viruscare Solution" />
            </div>
            <div class="back-card bg-img-card-f-4 background-wrapper">
              <img src="@/assets/images/solution/viruscare/back_card_03.png" alt="CESCO [Solution] Viruscare Solution" />
              <div class="content">
                <h4>Providing touchless automatic dispensers to prevent cross-contamination</h4>
                <p>Non-contact hand sanitizers and disinfection devices with automatic sensors ensure public places are safe to use.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section tab-area solution-viruscare-4">
      <div class="contents-center">
        <div class="tab-info">
          <h3 class="title-section">Virus & Bacteria Care System</h3>
          <p class="description-section">
            Infection prevention management blocks the routes of virus transmission, offering a comprehensive Viruscare Solution.
          </p>
        </div>

        <div class="tabs">
          <button
            v-for="item in tabList"
            :key="`tab-${item.id}`"
            :id="`tab-${item.id}`"
            :class="['tab-button', tab === item.id && 'active']"
            @click="handleTabClick(item.id)"
          >
            {{ item.name }}
          </button>
        </div>
        <button class="btn-list">Press the button to check.</button>
      </div>

      <div v-if="!mobileCheck" class="tab-contents">
        <div v-if="tab === 0" class="tab-content">
          <swiper :slides-per-view="'auto'" :centered-slides="true" :modules="[Autoplay]">
            <swiper-slide class="viruscare-slide-2">
              <div>
                <h5 class="title">
                  CESCO air sterilizers designed for preemptive attacks on viruses operates continuously in areas with frequent human traffic.
                </h5>
                <p class="description">
                  CESCO air sterilizers utilize motion detection smart care technology and smart auto mode to actively inhale contaminated air and
                  directly sterilize viruses. They effectively eliminate 99.99% of influenza and coronavirus, and 99.9% of bacteria that cause
                  pneumonia.
                </p>
              </div>
              <div>
                <img src="@/assets/images/solution/viruscare/tab02_01.png" alt="CESCO [Solution] Viruscare Solution" />
              </div>
            </swiper-slide>
            <swiper-slide class="viruscare-slide-2">
              <div>
                <h5 class="title">CESCO Fresh Gienic works 24/7 in bathrooms with a high risk of bacterial dispersion.</h5>
                <p class="description">
                  Bacteria dispersed with water droplets during toilet flushing can spread up to a maximum radius of 6 meters. CESCO automatic toilet
                  sanitizers eliminate 99.9% of bacteria residing in toilets and drainage pipes, effectively cleaning surfaces, deodorizing, removing
                  scale, and eliminating foul gases.
                </p>
              </div>
              <div>
                <img src="@/assets/images/solution/viruscare/tab02_02.png" alt="CESCO [Solution] Viruscare Solution" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div v-if="tab === 1" class="tab-content">
          <swiper
            :slides-per-view="'auto'"
            :centered-slides="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
          >
            <swiper-slide class="viruscare-slide-4">
              <p class="title">Vaccine in the Air</p>
              <h3 class="name">
                Air Sterilizer <br />
                Sense me
              </h3>
              <div class="image">
                <img src="@/assets/images/solution/viruscare/tab04_01.png" alt="CESCO [Solution] Viruscare Solution" />
              </div>
              <p class="description">Removes 99% of COVID-19 in the air, providing protection from viruses.</p>
            </swiper-slide>
            <swiper-slide class="viruscare-slide-4">
              <p class="title">Quickly Sterilizes Even the Largest Spaces</p>
              <h3 class="name">
                Air Sterilizer
                <br />
                Max Power
              </h3>
              <div class="image">
                <img src="@/assets/images/solution/viruscare/tab04_02.png" alt="CESCO [Solution] Viruscare Solution" />
              </div>
              <p class="description">Rapidly sterilizes vast spaces with two large sirocco fans and UV sterilization tunnels.</p>
            </swiper-slide>
            <swiper-slide class="viruscare-slide-4">
              <p class="title">
                Suitable for Installation in
                <br />
                Any Space
              </p>
              <h3 class="name">
                UV Power
                <br />Air Sterilizer
              </h3>
              <div class="image">
                <img src="@/assets/images/solution/viruscare/tab04_03.png" alt="CESCO [Solution] Viruscare Solution" />
              </div>
              <p class="description">Employing a carbon pre-filter and a mirror wall design, our sterilizer filters and discharges sterilized air.</p>
            </swiper-slide>
            <swiper-slide class="viruscare-slide-4">
              <p class="title">Air Purifier and Sterilizer Combined!</p>
              <h3 class="name">Air Sterilizer and Purifier Dual Care</h3>
              <div class="image">
                <img src="@/assets/images/solution/viruscare/tab04_04.png" alt="CESCO [Solution] Viruscare Solution" />
              </div>
              <p class="description">
                Equipped with a fine dust cleaning engine and a virus sterilization engine, our device manages air cleaning and sterilization both
                individually and collectively.
              </p>
            </swiper-slide>
            <swiper-slide class="viruscare-slide-4">
              <p class="title">Touchless Hand Sanitizer</p>
              <h3 class="name">Hand Gienic</h3>
              <div class="image">
                <img src="@/assets/images/solution/viruscare/tab04_06.png" alt="CESCO [Solution] Viruscare Solution" />
              </div>
              <p class="description">
                Operated by an automatic sensor, our touchless hand sanitizer prevents cross-contamination with harmful bacteria.
              </p>
            </swiper-slide>
            <swiper-slide class="viruscare-slide-4">
              <p class="title">Touchless Hand Sanitizer</p>
              <h3 class="name">Sani Gienic</h3>
              <div class="image">
                <img src="@/assets/images/solution/viruscare/tab04_07.png" alt="CESCO [Solution] Viruscare Solution" />
              </div>
              <p class="description">Sanigenic’s disinfectant eliminates 99.999% of bacteria effectively.</p>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>Our services include scientific <br class="pc_show" />management provided by an antibacterial <br class="pc_show" />safety expert.</h2>
      <p>If viruses cannot be prevented, the CESCO Viruscare System is necessary.</p>

      <router-link to="/contact/mail/send?local=eng" class="btn"> Send Email </router-link>
    </section>
  </main>

  <ModalView v-if="mobileCheck" :modal-state="modalState" @close-modal="closeModal">
    <VirusCareModalContent :tab="tab" :text="tabList[tab].name" />
  </ModalView>

  <ModalView v-if="mobileCheck" type="card" :modal-state="virusCareListModalState" @close-modal="closeVirusCareListsModal">
    <VirusCareListModalContent :tab="virusCare" />
  </ModalView>
</template>

<script setup>
import { inject, ref, watch } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { useMeta } from 'vue-meta'
import { useScroll, useModal, useTab } from '@/hooks'
import ModalView from '@/components/common/ModalView.vue'
import VirusCareModalContent from '@/components/modal/VirusCareModalContent.vue'
import VirusCareListModalContent from '@/components/modal/VirusCareListModalContent.vue'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()
const { modalState, openModal, closeModal } = useModal()
const { tab, handleTabClick } = useTab(openModal)

const mobileCheck = inject('mobileCheck')

const tabList = [
  { id: 0, name: '24-hour Advanced Air Management System' },
  { id: 1, name: 'Personal Hygiene Specialist Solution' }
]

// virusCareList modal
const virusCare = ref(0)
const virusCareListModalState = ref(false)

const openVirusCareListModal = () => {
  virusCareListModalState.value = true
}

const closeVirusCareListsModal = () => {
  virusCareListModalState.value = false
}

const handleVirusCareClick = index => {
  if (!mobileCheck.value) return

  virusCare.value = index
  openVirusCareListModal()
}

watch(virusCareListModalState, value => {
  value ? (document.body.style.overflow = 'hidden') : document.body.style.removeProperty('overflow')
})

useMeta({
  title: 'CESCO - Viruscare Solution',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Scientific Management by Antimicrobial Safety Experts'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/viruscare.scss';
</style>
